module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by unit no., bhk, sq ft, etc.' : 'Search',
      "single-line": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.unitHeadSm,
      "items": _vm.units,
      "title": "Unit list"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.unitHeadSm : _vm.unitHead,
      "items": _vm.units,
      "hide-actions": "",
      "search": _vm.search,
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareUpdate(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.block_nm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.unit_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.bhk))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.acc_sqft))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          class: props.item.is_rented ? 'accent--text' : ''
        }, [_vm._v(_vm._s(props.item.is_rented ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          class: props.item.is_billed_to_tenant ? 'accent--text' : ''
        }, [_vm._v(_vm._s(props.item.is_billed_to_tenant ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          class: props.item.is_vacant ? 'accent--text' : ''
        }, [_vm._v(_vm._s(props.item.is_vacant ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.spcl_cat))]) : _vm._e()])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300px"
    },
    model: {
      value: (_vm.isUpdated),
      callback: function($$v) {
        _vm.isUpdated = $$v
      },
      expression: "isUpdated"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.lUnit.block_nm + ' ' + _vm.lUnit.unit_no))])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "BHK",
      "rules": [_vm.rules.required],
      "items": _vm.bhkList,
      "type": "number"
    },
    model: {
      value: (_vm.lUnit.bhk),
      callback: function($$v) {
        _vm.$set(_vm.lUnit, "bhk", $$v)
      },
      expression: "lUnit.bhk"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sq Ft",
      "rules": [_vm.rules.required],
      "type": "number"
    },
    model: {
      value: (_vm.lUnit.acc_sqft),
      callback: function($$v) {
        _vm.$set(_vm.lUnit, "acc_sqft", $$v)
      },
      expression: "lUnit.acc_sqft"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Vacant",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.lUnit.is_rented = _vm.lUnit.is_rented && _vm.lUnit.is_vacant ? false : _vm.lUnit.is_rented
      }
    },
    model: {
      value: (_vm.lUnit.is_vacant),
      callback: function($$v) {
        _vm.$set(_vm.lUnit, "is_vacant", $$v)
      },
      expression: "lUnit.is_vacant"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Rented out",
      "disabled": _vm.lUnit.is_vacant,
      "hide-details": ""
    },
    model: {
      value: (_vm.lUnit.is_rented),
      callback: function($$v) {
        _vm.$set(_vm.lUnit, "is_rented", $$v)
      },
      expression: "lUnit.is_rented"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Billed to tenant",
      "disabled": !_vm.lUnit.is_rented || _vm.lUnit.is_vacant,
      "hide-details": ""
    },
    model: {
      value: (_vm.lUnit.is_billed_to_tenant),
      callback: function($$v) {
        _vm.$set(_vm.lUnit, "is_billed_to_tenant", $$v)
      },
      expression: "lUnit.is_billed_to_tenant"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Special billing category (optional)",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lUnit.spcl_cat),
      callback: function($$v) {
        _vm.$set(_vm.lUnit, "spcl_cat", $$v)
      },
      expression: "lUnit.spcl_cat"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": Number(_vm.lUnit.acc_sqft) <= 0,
      "color": "accent",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveChanges.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20%",
      "left": "50%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24b1de74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Unit.vue
// module id = 905
// module chunks = 18